module.exports = __webpack_public_path__ + "static/media/logout.83c4c54d.svg";